export const HOST_URL = 'https://pare-afb7e.web.app/';
